import { api } from "helpers/api";
import { TrackerInput } from "model/object/tracker";

const useTracker = () => {
	const track = async (input: TrackerInput) => {
		return await api.post("/tracker", input);
	};

	return track;
};

export default useTracker;
